module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_goodcen_m.0b7ce2faf813833213ad89cda428d58b.png";